// Utility functions for parsing gallery data

/**
 * For engagement galleries, venue field may contain "location||season" format
 * This parses that format and returns separate location and season values
 */
export function parseEngagementVenue(venue: string | null): { location: string | null; season: string | null } {
  if (!venue) {
    return { location: null, season: null };
  }
  
  if (venue.includes("||")) {
    const [location, season] = venue.split("||");
    return {
      location: location || null,
      season: season || null,
    };
  }
  
  // Legacy format - venue is just venue, no season
  return { location: venue, season: null };
}

/**
 * Format season string for display (capitalize first letter, add "Session")
 */
export function formatSeason(season: string | null): string | null {
  if (!season) return null;
  return `${season.charAt(0).toUpperCase()}${season.slice(1)} Session`;
}
